export default
{
    name: 'app-img-bg',

    props:
    {
        src: { type: String },
        position: { type: String, default: 'center' },
        size: { type: String, default: 'cover' },
        fit: { type: Boolean, default: true }
    },

    data()
    {
        return {
            style: {},
            isLoading: true
        }
    },

    created()
    {
        const style = {
            backgroundImage: 'url("' + this.src + '")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: this.position,
            backgroundSize: this.size,
            width: '100%',
            height: '100%'
        }

        this.style = style
    },

    methods:
    {
        _onLoad()
        {
            const img = new Image()
            img.src = this.src

            img.onload = () =>
            {
                this.isLoading = false

                this.width = img.width
                this.height = img.height

                const style = {
                    backgroundImage: 'url("' + this.src + '")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: this.position,
                    backgroundSize: this.size,
                    width: '100%',
                    height: '100%'
                }

                if (!this.fit)
                {
                    const imgRatio = this.$el.querySelector('.js-loader-img-hidden').offsetWidth / this.$el.querySelector('.js-loader-img-hidden').offsetHeight

                    style.height = imgRatio < 1 ? `${this.$el.offsetWidth * imgRatio}px` : `${this.$el.offsetWidth / imgRatio}px`
                }

                this.$el.classList.add('is-load')

                this.style = style

                if (this.$el.querySelector('.js-loader-img-hidden'))
                {
                    this.$el.removeChild(this.$el.querySelector('.js-loader-img-hidden'))
                }

                this.eventHub.$emit('app-img-bg:image-loaded', this)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-img-bg/script.js